// extracted by css-extract-rspack-plugin
export default {"wrapper":"_de0aa4c6","topVisibilityOffset":"_eec203b5","menu":"_bb8b106","scrollBar":"_31d69729","fullHeight":"_5af847d9"};